import { useEffect, useState } from "react";
import { navLinks, tickerItems } from "@/mocks/home";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const tickerLoop = [...tickerItems, ...tickerItems];

  return (
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className="bg-foreground-950 text-background-50">
        <div className="flex items-center h-9">
          <span className="hidden sm:flex items-center gap-1.5 shrink-0 h-full px-4 md:px-6 bg-primary-500 text-foreground-950 font-label text-xs font-medium tracking-wide">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-pulse-line text-[14px]"></i>
            </span>
            更新条
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-ticker">
              {tickerLoop.map((item, index) => (
                <span
                  key={index}
                  className="flex items-center whitespace-nowrap font-label text-xs text-background-200 px-4"
                >
                  <span className="w-3 h-3 mr-2 flex items-center justify-center text-primary-400">
                    <i className="ri-circle-fill text-[4px]"></i>
                  </span>
                  {item}
                </span>
              ))}
            </div>
            <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-foreground-950 to-transparent" />
          </div>
          <a
            href="#entry"
            className="hidden md:flex items-center gap-1 shrink-0 h-full pl-4 pr-6 font-label text-xs text-background-100 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
          >
            直达入口
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line text-[13px]"></i>
            </span>
          </a>
        </div>
      </div>

      <div
        className={`transition-colors duration-300 border-b ${
          scrolled
            ? "bg-background-50/95 backdrop-blur border-background-200"
            : "bg-transparent border-transparent"
        }`}
      >
        <div className="w-full flex items-center justify-between h-16 px-4 md:px-6">
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
            <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-foreground-950 font-heading text-lg font-bold">
              黑
            </span>
            <span className="flex flex-col leading-none">
              <h1 className="font-heading text-lg font-bold tracking-wide text-foreground-950">
                黑料网5
              </h1>
              <span className="font-label text-[11px] text-foreground-600 mt-0.5">
                分站特色导览
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-3.5 py-2 rounded-md font-label text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <div className="hidden md:flex items-center h-10 pl-3 pr-1 rounded-md border border-background-200 bg-background-100">
              <span className="w-5 h-5 flex items-center justify-center text-foreground-500">
                <i className="ri-search-line text-[16px]"></i>
              </span>
              <input
                type="text"
                placeholder="搜方向 / 标签"
                aria-label="搜索方向或标签"
                className="w-40 bg-transparent border-none outline-none font-label text-sm text-foreground-900 placeholder:text-foreground-500 px-2"
              />
              <button
                type="button"
                className="h-8 px-3 rounded-md bg-foreground-950 text-background-50 font-label text-xs hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                搜索
              </button>
            </div>

            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="展开导航菜单"
              className="lg:hidden w-10 h-10 flex items-center justify-center rounded-md border border-background-200 text-foreground-900 cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-[20px]" : "ri-menu-line text-[20px]"}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-3">
            <div className="flex flex-col">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="py-3 border-b border-background-100 last:border-b-0 font-label text-sm text-foreground-800 cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
            <div className="flex items-center h-11 mt-3 pl-3 pr-1 rounded-md border border-background-200 bg-background-100">
              <span className="w-5 h-5 flex items-center justify-center text-foreground-500">
                <i className="ri-search-line text-[16px]"></i>
              </span>
              <input
                type="text"
                placeholder="搜方向 / 标签"
                aria-label="搜索方向或标签"
                className="flex-1 bg-transparent border-none outline-none font-label text-sm text-foreground-900 placeholder:text-foreground-500 px-2"
              />
            </div>
          </div>
        )}
      </div>
    </header>
  );
}